import styled, { css } from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | undefined;
}

export const PlayIcon = styled.span<IProps>`
  transform: translateZ(0);
  ${mixin.flex({})};
  overflow: hidden;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 56px;
  width: 32px;
  height: 32px;
  transition: opacity 0.3s;

  svg {
    margin-right: auto;
    margin-left: 13px;
  }

  ${props => {
    if (props.size === 'xs') {
      return css`
        width: 16px;
        height: 16px;

        svg {
          width: 5px;
          height: 6px;
          margin-left: 6px;
        }
      `;
    }

    if (props.size === 'sm') {
      return css`
        width: 26px;
        height: 26px;

        svg {
          width: 8px;
          height: 8px;
          margin-left: 10px;
        }
      `;
    }

    if (props.size === 'lg') {
      return css`
        width: 36px;
        height: 36px;

        svg {
          width: 11px;
          height: 12px;
          margin-left: 14px;
        }
      `;
    }

    if (props.size === 'xl') {
      return css`
        width: 56px;
        height: 56px;

        svg {
          width: 18px;
          height: 20px;
          margin-left: 22px;
        }
      `;
    }

    return null;
  }}

  @media ${({ theme }) => theme.media.smMax} {
    border-radius: ${mixin.pxToVw('50')};
    width: ${mixin.pxToVw('32')};
    height: ${mixin.pxToVw('32')};

    svg {
      width: ${mixin.pxToVw('9')};
      height: ${mixin.pxToVw('10')};
      margin-left: ${mixin.pxToVw('13')};
    }

    ${props => {
      if (props.size === 'xs') {
        return css`
          width: ${mixin.pxToVw('16')};
          height: ${mixin.pxToVw('16')};

          svg {
            width: ${mixin.pxToVw('5')};
            height: ${mixin.pxToVw('6')};
            margin-left: ${mixin.pxToVw('6')};
          }
        `;
      }

      if (props.size === 'sm') {
        return css`
          width: ${mixin.pxToVw('26')};
          height: ${mixin.pxToVw('26')};

          svg {
            width: ${mixin.pxToVw('8')};
            height: ${mixin.pxToVw('8')};
            margin-left: ${mixin.pxToVw('10')};
          }
        `;
      }

      if (props.size === 'lg') {
        return css`
          width: ${mixin.pxToVw('36')};
          height: ${mixin.pxToVw('36')};

          svg {
            width: ${mixin.pxToVw('11')};
            height: ${mixin.pxToVw('12')};
            margin-left: ${mixin.pxToVw('15')};
          }
        `;
      }

      if (props.size === 'xl') {
        return css`
          width: ${mixin.pxToVw('56')};
          height: ${mixin.pxToVw('56')};

          svg {
            width: ${mixin.pxToVw('18')};
            height: ${mixin.pxToVw('20')};
            margin-left: ${mixin.pxToVw('22')};
          }
        `;
      }

      return null;
    }}
  }
`;
